var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{class:[_vm.s.header, ( _obj = {}, _obj[_vm.s.sp] = _vm.$device.isMobileOrTablet, _obj )]},[_c('img',{class:_vm.s.logo,attrs:{"src":require("assets/images/logo_v2.svg")}}),_vm._v(" "),_c('img',{class:_vm.s.logo_sp,attrs:{"src":require("assets/images/logo_v2.svg")}})])]),_vm._v(" "),_c('Nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }